module.exports = __webpack_public_path__ + "img/gmdl_icon5.3bcef318.png";